import React from "react";
import imgone from "../../assets/images/sucess-img.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuceess = () => {
  const location = useLocation();
  const { orderId } = location.state || {};
  const navigate = useNavigate();

  const navigatehome = () => {
    navigate("/");
  };

  const navorder = () => {
    navigate("/Orders");
  };

  return (
    <div className="payment-success-bg pt-80  pb-80">
      <div className="container">
        <div className="row order-row">
          <div className="col-lg-6 success-img-main">
            <img src={imgone} alt="success-img" />
          </div>
          <div className="col-lg-6 order-success-cont">
            <div className="success-round-main">
              <div className="success-round">
                <FontAwesomeIcon icon={faCheck} />
              </div>
            </div>
            <h2>Order Placed Successfully !</h2>
            <p>
              Your Payment had been done successfully.<br />
              Thankyou for shopping.
            </p>
            <h6>
              Order ID: {orderId || "N/A"}
            </h6>
            <button className="track-btn" onClick={navorder}>
              Track Order
            </button>
            <br />
            <button className="ctnue-shop" onClick={navigatehome}>
              Countinue Shopping
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuceess;
